import { Controller } from '@hotwired/stimulus';

export default class FormPreventDefaultController extends Controller {
  connect() {
    this.element.addEventListener('submit', handler);
  }

  disconnect() {
    this.element.removeEventListener('submit', handler);
  }
}

const handler = (event) => {
  event.preventDefault();
  return false;
}
